
export type UserProfileResponsePreferencesTheme = typeof UserProfileResponsePreferencesTheme[keyof typeof UserProfileResponsePreferencesTheme];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserProfileResponsePreferencesTheme = {
  light: 'light',
  dark: 'dark',
  auto: 'auto',
} as const;
